module.exports = __webpack_public_path__ + "img/img47.79c02a9d.png";